import { render, staticRenderFns } from "./Regulations.vue?vue&type=template&id=79b73e0e"
import script from "./Regulations.vue?vue&type=script&lang=js"
export * from "./Regulations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports